/**
 * User-facing labels for opening a Basecamp todo from Maater chrome.
 * Icons: OpenDestinationIcons.open (in-app) vs resolveOpenExternalIcon(BasecampIcon).
 */
export function basecampViewTodoLabel(recordType?: 'todo' | 'todolist'): string {
  return recordType === 'todolist' ? 'View todo list' : 'View todo'
}

export const BASECAMP_VIEW_PROJECT_LABEL = 'View project'

export const BASECAMP_OPEN_IN_BASECAMP_LABEL = 'Open in Basecamp'
